<script setup lang="ts">
import { HeartIcon } from '@heroicons/vue/24/solid';
import type { IGameCategory } from '~/interfaces/dto/games/response';
import { useAuthStore } from '~/stores/auth.store';
import { useGameStore } from '~/stores/games.store';

interface IFavouriteProps {
  game: IGameCategory | null;
  fill?: string;
}

const { $trackEvent } = useNuxtApp();
const props = withDefaults(defineProps<IFavouriteProps>(), {
  fill: 'text-light-50',
});
const auth = useAuthStore();
const gameStore = useGameStore();
const { $gameService } = useServices();

async function addFavorite() {
  await $gameService.addGameFavourites({
    game: props.game,
  });
  $trackEvent('GameEvent', 'FAVOURITE_GAME_ADD', {
    game_name: props?.game?.name,
    game_alias: props?.game?.alias,
    game_id: props?.game?.id,
    msisdn: auth?.currentUser?.username,
  });
}

async function removeFavorite() {
  await $gameService.deleteGameFavourites({
    game: props.game,
  });
  $trackEvent('GameEvent', 'FAVOURITE_GAME_REMOVE', {
    game_name: props?.game?.name,
    game_alias: props?.game?.alias,
    game_id: props?.game?.id,
    msisdn: auth?.currentUser?.username,
  });
}

function favoriteClicked(e: Event) {
  e.stopImmediatePropagation();
  if (auth.isLoggedIn)
    return isFavorite.value ? removeFavorite() : addFavorite();
  else window.openModal('login');
}

const isFavorite = computed(() =>
  gameStore.isFavorite(props.game?.id?.toString()),
);
</script>

<template>
  <div
    :aria-label="`${$t('favorite-game')} ${game?.name}`"
    class="hover:cursor-pointer"
    @click.stop="favoriteClicked"
  >
    <HeartIcon
      class="w-6"
      :class="isFavorite ? 'primary-pink-gradient-text' : props?.fill"
    />
  </div>
</template>
